import { AddressVerificationState } from '@/lib/enums/AddressVerificationState'

type AddressVerificationStateOption =
  (typeof AddressVerificationState)[keyof typeof AddressVerificationState]

/** An address verification state with the label admin shows for it. */
export type AdminAddressVerificationState = Omit<AddressVerificationStateOption, 'Label'> & {
  Label: string
}

export function withAdminAddressVerificationLabel(
  state: AddressVerificationStateOption
): AdminAddressVerificationState {
  if (state.Value === AddressVerificationState.VerifiedApproximate.Value) {
    return {
      ...state,
      Label: 'Verify',
    }
  }

  return state
}
